import { render, staticRenderFns } from "./CheckoutSessionPage.vue?vue&type=template&id=2a856f2b"
import script from "./CheckoutSessionPage.vue?vue&type=script&lang=js"
export * from "./CheckoutSessionPage.vue?vue&type=script&lang=js"
import style0 from "./CheckoutSessionPage.vue?vue&type=style&index=0&id=2a856f2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports